import * as tslib_1 from "tslib";
import { MatDialogRef } from '@angular/material';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { MessageService } from '@core/errors/messages-service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { UsersService } from '../../services/users-resolver.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var DialogArchiveOrUnarchiveUserComponent = /** @class */ (function () {
    function DialogArchiveOrUnarchiveUserComponent(data, matDialogRef, fuseTranslationLoaderService, customMessageService, fuseProgressBarService, messageService, usersService) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.customMessageService = customMessageService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.messageService = messageService;
        this.usersService = usersService;
        this.isLoading = false;
        this.isArchived = false;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.userId = this.data.userId;
        this.isArchived = this.data.isArchived;
        this.isLoading = this.data.isLoading;
    }
    DialogArchiveOrUnarchiveUserComponent.prototype.archiveOrUnarchiveUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, 6, 7]);
                        this.isLoading = true;
                        this.fuseProgressBarService.show();
                        if (!this.isArchived) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.usersService.archivedUser(this.userId).toPromise()];
                    case 1:
                        _a.sent();
                        this.customMessageService.success('ARCHIVE_OR_UNARCHIVE_USER_DIALOG.ARCHIVE.SUCCESS_MESSAGE');
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.usersService.unarchiveUser(this.userId).toPromise()];
                    case 3:
                        _a.sent();
                        this.customMessageService.success('ARCHIVE_OR_UNARCHIVE_USER_DIALOG.UNARCHIVE.SUCCESS_MESSAGE');
                        _a.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        error_1 = _a.sent();
                        this.messageService.error(error_1);
                        if (this.isArchived) {
                            this.customMessageService.error('ARCHIVE_OR_UNARCHIVE_USER_DIALOG.ARCHIVE.ERROR_MESSAGE');
                        }
                        else {
                            this.customMessageService.error('ARCHIVE_OR_UNARCHIVE_USER_DIALOG.UNARCHIVE.ERROR_MESSAGE');
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        this.matDialogRef.close({ reload: true });
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    DialogArchiveOrUnarchiveUserComponent.prototype.closeDialog = function () {
        this.matDialogRef.close();
    };
    return DialogArchiveOrUnarchiveUserComponent;
}());
export { DialogArchiveOrUnarchiveUserComponent };
